interface BaseSubmitData {
    jobDescription?: string;
    postcode?: string;
    isNationalLead?: string;
    buyerName?: string;
    buyerEmail?: string;
    phoneNumber?: string;
    qaList?: any;
    formType: string;
    sellerSource: string;
    requestId: string;
    buyerId: string;
    sourceURL: string;
    gtCateId: string;
    sellerSkillId: any;
    sellerSkill: any;
}

export const buildBaseSubmitData = (
    describeFormData: any,
    contactFormData: any,
    qaList: any[],
    requestId: string,
    userId: string,
    currentPageUrl: string,
    categoryId: string,
    selectedService: any,
    formType: string
): BaseSubmitData => {
    return {
        jobDescription: describeFormData.jobDescription,
        postcode: describeFormData.postcode,
        isNationalLead: describeFormData.remote || 'none',
        buyerName: contactFormData.buyerName,
        buyerEmail: contactFormData.buyerEmail,
        phoneNumber: contactFormData.phoneNumber,
        qaList: describeFormData.qaList ? {
            [qaList.find(qa => qa.answers.some((answer: any) => answer.answerId === describeFormData.qaList))?.questionId || '']: [describeFormData.qaList]
        } : {},
        formType,
        sellerSource: 'Bark',
        requestId,
        buyerId: userId,
        sourceURL: currentPageUrl,
        gtCateId: categoryId,
        sellerSkillId: selectedService?.id || selectedService?.value || null,
        sellerSkill: selectedService?.displayName || null
    };
};
